module.exports = __webpack_public_path__ + "img/video_course.a0a6c384.png";